const en = {
  "nav.search": "Search...",
  "nav.moreOptions": "More options",
  "nav.hide": "Hide",
  "nav.show": "Show",
  "nav.logout": "Log out",
  "nav.language": "Language",
  "nav.dashboard": "Dashboard",
  "nav.inbox": "Inbox",
  "nav.crm": "CRM",
  "nav.agenda": "Calendar",
  "nav.business": "My business",
  "nav.admin": "Administration",
  "nav.email": "Email",
  "nav.whatsapp": "WhatsApp",
  "nav.marketing": "Marketing",
  "nav.plan": "My plan",
  "nav.integrations": "Integrations",
  "nav.setup": "Auto attendance",
  "nav.ai": "AI settings",
  "nav.reports": "Reports",
  "nav.social": "Social & Ads",
  "nav.web": "Website",
  "mkt.title": "Marketing",
  "mkt.sub": "Acquisition and growth. Mass email and WhatsApp live in the side menu.",
  "mkt.home": "Home",
  "mkt.origins": "Lead sources",
  "mkt.lists": "Lists",
  "mkt.automations": "Sequences",
  "mkt.more": "More",
  "mkt.campaigns": "Campaigns (advanced)",
  "mkt.contacts": "Contacts",
  "mkt.schedules": "Send calendar",
  "mkt.delivery": "Delivery tests",
  "mkt.whatToday": "What do you want to do today?",
  "mkt.whatTodaySub": "Acquisition lives here (QR, lists, automations). For mass email or WhatsApp use the side menu.",
  "mkt.originsTitle": "Lead sources",
  "mkt.originsSub": "WhatsApp by phrase, QR, portals, web…",
  "mkt.originsP1": "Create a QR with a starter message",
  "mkt.originsP2": "The lead writes and enters your flow / AI",
  "mkt.originsP3": "Download and print in seconds",
  "mkt.originsCta": "Configure sources",
  "mkt.audienceTitle": "Lists and audiences",
  "mkt.audienceSub": "Who you talk to in each send",
  "mkt.audienceP1": "Landing or form connected to CRM",
  "mkt.audienceP2": "Triggers flows and assignment",
  "mkt.audienceP3": "Ideal for digital campaigns",
  "mkt.audienceCta": "View sources",
  "mkt.segmentsTitle": "Lists / segments",
  "mkt.segmentsText": "Who you message (birthdays, CRM stage, dates…)",
  "mkt.autoTitle": "Nurturing sequences",
  "mkt.nurtureHint": "Configure how leads are nurtured automatically by email and WhatsApp.",
  "mkt.autoText": "Welcome, appointments, birthdays, win-back and more. They run themselves.",
  "mkt.massSection": "Mass sends (separate modules)",
  "mkt.emailMass": "Mass email",
  "mkt.emailMassSub": "SES mailing · templates · reports",
  "mkt.waMass": "Mass WhatsApp",
  "mkt.waMassSub": "Meta templates · sends · API connection",
  "mkt.statLeads": "Leads",
  "mkt.statTpl": "WA templates",
  "mkt.statDrafts": "Draft campaigns",
  "mkt.statAuto": "Active automations",
  "email.home": "Home",
  "email.new": "New send",
  "email.history": "History",
  "email.templates": "Templates",
  "email.domain": "My domain",
  "email.reports": "Reports",
  "email.title": "Email",
  "email.sub": "Mass email under your brand",
  "wa.home": "Home",
  "wa.connection": "Connection",
  "wa.sends": "Sends",
  "wa.templates": "Templates",
  "wa.reports": "Reports",
  "wa.title": "WhatsApp",
  "wa.sub": "Mass sends and Business API connection",
  "crm.pipeline": "Pipeline",
  "crm.leads": "Leads",
  "crm.tasks": "Tasks",
  "crm.templates": "Templates",
  "inbox.all": "All",
  "inbox.open": "Open",
  "inbox.closed": "Closed",
  "agenda.calendar": "Calendar",
  "agenda.resources": "Services and resources",
  "agenda.tables": "Floor plan",
  "biz.summary": "My business",
  "biz.team": "My team",
  "biz.assignment": "Assignment",
  "biz.flows": "Lead path",
  "biz.profile": "Profile and hours",
  "biz.locations": "Locations",
  "rep.status": "Status",
  "rep.detail": "Technical detail",
  "common.loading": "Loading…",
  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.next": "Next",
  "common.back": "Back",
  "common.edit": "Edit",
  "common.delete": "Delete",
  "common.create": "Create",
  "common.view": "View",
  "common.close": "Close",
  "common.copy": "Copy",
  "common.search": "Search",
  "common.active": "Active",
  "common.inactive": "Inactive",
  "origins.title": "Lead sources",
  "origins.sub": "One source = medium + entry path + campaign. WhatsApp, call, webhook or smart email.",
  "origins.create": "Create source",
  "origins.edit": "Edit",
  "origins.connection": "Connection details",
  "origins.webhook": "Webhook",
  "origins.email": "Smart email",
  "origins.secret": "Secret",
  "origins.secretOnce": "Secret (copy now; full value is shown only once)",
  "origins.regen": "Regenerate secret",
  "origins.copy": "Copy",
  "origins.free": "Free WhatsApp messages",
  "origins.freeHelp": "Always on. Chats without a campaign phrase, or if the lead clears the prefilled text.",
  "origins.empty": "No sources yet",
  "origins.leads": "leads",
  "origins.save": "Save changes",
  "origins.close": "Close",
  "origins.howTo": "How to connect",
  "lang.es": "Español",
  "lang.en": "English",
  "lang.de": "Deutsch",
  "lang.pt": "Português",
  "lang.choose": "Language",
  "lang.auto": "Automatic (by region)",
  "login.title": "Sign in",
  "login.subtitle": "Access your business",
  "login.email": "Email",
  "login.password": "Password",
  "login.name": "Name",
  "login.submit": "Sign in",
  "login.register": "Create account",
  "login.haveAccount": "Already have an account? Sign in",
  "login.noAccount": "Don't have an account? Sign up",
  "login.forgot": "Forgot your password?",
  "login.mfa": "Two-step verification",
  "login.mfaHint": "Enter the 6-digit code from your authenticator app, or a backup code.",
  "login.code": "Code",
  "login.inactive": "Your session ended after 60 minutes of inactivity.",
  "login.titleRegister": "Create account",
  "login.titleLogin": "Sign in",
  "login.emailLabel": "Email",
  "login.passwordLabel": "Password",
  "login.nameLabel": "Full name",
  "login.submitLogin": "Sign in",
  "login.submitRegister": "Create account",
  "login.switchToLogin": "Already have an account? Sign in",
  "login.switchToRegister": "Don't have an account? Sign up",
  "login.heroTitle": "Your business, automated",
  "login.heroSub": "Support, sales and follow-up in one place.",
  "login.verify": "Verify",
  "dash.welcome": "Welcome",
  "dash.overview": "Your business overview",
  "admin.pos": "Point of sale",
  "admin.warranty": "Service desk",
  "admin.condo": "Condo management",
  "admin.sub": "Business operations: point of sale and cash register",
  "filtros.from": "From",
  "filtros.to": "To",
  "filtros.seller": "Salesperson",
  "filtros.group": "Group",
  "filtros.campaign": "Campaign",
  "filtros.clear": "Clear filters",
  "common.all": "All",
  "common.all_f": "All",
};
export default en;
